var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "mb-5" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Documents en attente de vérification")))
      ]),
      _vm._v(" "),
      _c("upload-form", {
        attrs: { linkedtype: _vm.linkedtype, hash: _vm.hash }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "fs-3 wp-4 mx-auto acenter" }, [
        _c("p", { staticClass: "black m-0 mb-2" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Envoyer des documents par email")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "grey m-0 mb-2" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "ocr.%s@sellsy.net depuis l’adresse d’un collaborateur du compte.",
                  this.corpId
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "grey m-0 mb-2" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__("PDF de maximum 5 pages et inférieur à 5MB.")
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "grey m-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("(Envoi limité à 50 fichiers à la fois)")))
        ])
      ]),
      _vm._v(" "),
      _vm.canValidatePurInvoice
        ? _c(
            "div",
            { staticClass: "flex-row flex-right" },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("ocr.OcrList.check_all_documents"),
                  type: "primary",
                  disabled: !_vm.rows.length
                },
                on: { click: _vm.verifyAll }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listingData
        ? _c(
            "listing",
            _vm._b(
              {
                attrs: { storeModule: _vm.storeModule },
                on: { listinghash: _vm.storeRows }
              },
              "listing",
              _vm.listingData,
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }